<div class="datatable-footer-content">
  <div class="page-count">
    @if (selectedCount() > 0) {
      <span> {{ selectedCount().toLocaleString() }} {{ 'TABLE_SELECTED' | translate }} / </span>
    }
    {{ rowCount().toLocaleString() }} {{ 'TOTAL_TABLE_FOOTER' | translate }}
  </div>

  <div class="datatable-footer-content__limit">
    <label class="datatable-footer-content__label">{{ 'LIMIT' | translate }}</label>
    <select
      class="datatable-footer-content__select"
      [(ngModel)]="pageSize"
      (change)="onPageSizeChange($any($event.target).value)">
      @for (option of pageSizeOptions(); track option) {
        <option [value]="option">{{ option }}</option>
      }
    </select>
  </div>

  <datatable-pager
    [page]="offset()"
    [size]="pageSize"
    [count]="rowCount()"
    pagerLeftArrowIcon="datatable-icon-left"
    pagerRightArrowIcon="datatable-icon-right"
    pagerPreviousIcon="datatable-icon-prev"
    pagerNextIcon="datatable-icon-skip"
    (change)="onPageChange($event)"></datatable-pager>
</div>
